import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { MenuItem } from 'primeng/api';
import { AppMenuitem } from './app.menuitem';
import { AuthService } from '../../core/services/auth-service';

@Component({
  selector: 'app-menu',
  standalone: true,
  imports: [CommonModule, AppMenuitem, RouterModule],
  template: `<ul class="layout-menu">
    <ng-container *ngFor="let item of model; let i = index">
      <li app-menuitem *ngIf="!item.separator" [item]="item" [index]="i" [root]="true"></li>
      <li *ngIf="item.separator" class="menu-separator"></li>
    </ng-container>
  </ul> `,
})
export class AppMenu {
  model: MenuItem[] = [];

  constructor(private auth: AuthService) {}

  ngOnInit() {
    const roleId = this.auth.getRoleId() ?? 1; // پیش‌فرض: admin

    if (roleId === 3) {
      // ورزشکار
      this.model = [
        {
          label: 'باشگاه شاداب',
          items: [
            { label: 'داشبورد', icon: 'pi pi-fw pi-home', routerLink: ['/'] },
            { label: 'اطلاعات ورزشکار', icon: 'pi pi-fw pi-id-card', routerLink: ['/athlete-info'] },
          ],
        },
      ];
      return;
    }

    // ادمین
    this.model = [
      {
        label: 'باشگاه شاداب',
        items: [
          { label: 'داشبورد', icon: 'pi pi-fw pi-home', routerLink: ['/'] },
          { label: 'اطلاعات ورزشکار', icon: 'pi pi-fw pi-id-card', routerLink: ['/athlete-info'] },
        ],
      },
      {
        label: 'ثبت نام و حضورغیاب',
        items: [
          { label: 'ورزشکاران', icon: 'pi pi-fw pi-heart', routerLink: ['/athletes'] },
          { label: 'حضورغیاب', icon: 'pi pi-fw pi-check-square', routerLink: ['/attendance'] },
        ],
      },
      {
        label: 'اطلاعات پایه',
        items: [
          { label: 'آسیب های ورزشی', icon: 'pi pi-fw pi-exclamation-triangle', routerLink: ['/sportInjuries'] },
          { label: 'رشته های ورزشی', icon: 'pi pi-fw pi-trophy', routerLink: ['/SportDiscipline'] },
          { label: 'مربی ها', icon: 'pi pi-fw pi-verified', routerLink: ['/coaches'] },
          { label: 'کلاس ها', icon: 'pi pi-fw pi-calendar', routerLink: ['/classes'] },
        ],
      },
      {
        label: 'گزارش های مدیریتی',
        items: [
          { label: 'گزارش کلاس ها', icon: 'pi pi-fw pi-chart-line', routerLink: ['/class-reports'] },
          { label: 'تاریخ های در حال انقضا', icon: 'pi pi-fw pi-clock', routerLink: ['/expiring'] },
          { label: 'گزارش کاربران', icon: 'pi pi-fw pi-sign-in', routerLink: ['/userLog'] },
        ],
      },
    ];
  }
}
